module.exports = __webpack_public_path__ + "img/compact.612e119a.png";